import { createFileRoute } from '@tanstack/react-router'
import { SignatureRequestsPage } from '../../../components/signatures/SignatureRequestsPage'

/** Signature requests in progress and done (spec 2026-10-05-05). The status filter lives in the URL. */
export const Route = createFileRoute('/$org/signatures/')({
  component: SignatureRequestsPage,
  validateSearch: (search: Record<string, unknown>) => ({
    status: search.status ? String(search.status) : undefined,
  }),
})
